import { computed, observable } from 'mobx';
import merge from 'lodash/merge';
import { IChildLayout, TBlockType, TLayoutType } from '~/types/model.types';
import {
    TBlockResponse,
    IContainerableBlockResponse
} from '~/types/server.types';
import { CXBaseBlock } from '~/components/ClientExperience/OneFlow/models/cx-base-block.model';
import type { CXRootStore } from '~/components/ClientExperience/stores/cx-root.store';
import type {
    IContainerableBlock,
    ContainerableBlock
} from '~/models/blocks/containerable-block.model';
import { TBlock } from '~/types/builder.types';
import type { FlowRevision } from '~/models/flow-revision.model';

export class CXContainerableBlock
    extends CXBaseBlock
    implements IContainerableBlock
{
    @observable layout_type: TLayoutType;
    @observable children: IChildLayout[];

    constructor(
        {
            children,
            ...block
        }: IContainerableBlockResponse | ContainerableBlock,
        flowRevision: FlowRevision<CXRootStore>,
        rootStore: CXRootStore
    ) {
        super(block as TBlockResponse | TBlock, flowRevision, rootStore);
        this.type = block.type;

        // if (block instanceof ContainerableBlock) {
        //     this._children = (<ContainerableBlock>block)._children;
        // } else {
        //     this._children = children as IChildLayout[];
        // }
        //
        this.children = children || [];
    }

    @computed
    get sortedChildLayouts() {
        return this.children
            .slice()
            .sort((a, b) => a.order - b.order)
            .filter(Boolean);
    }

    @computed
    get childBlocks() {
        return this.sortedChildLayouts
            .map(
                childLayout =>
                    this.rootStore.flowStore.blocks[childLayout.block_id]
            )
            .filter(Boolean);
    }

    @computed
    get blockInputValidations(): any {
        return this.allDescendants().reduce(
            (invalidations, child) =>
                merge(invalidations, child.blockInputValidations),
            {}
        );
    }

    get page() {
        return this.rootStore.flowStore.pages[this.page_id];
    }

    @computed
    get isRootBlock() {
        return this.block_id === this.page.root_block_id;
    }

    @computed
    get isRootChild() {
        return this.parent && this.parent.isRootBlock;
    }

    // Returns all children recursively
    allDescendants() {
        let { childBlocks } = this;
        const ContainerableBlockTypes: Array<TBlockType> = [
            'charge_container_block',
            'container_block',
            'contract_block',
            'invoice_container_block',
            'invoice_service_item_block',
            'lead_details_block',
            'payment_schedule_block',
            'recurring_schedule_block',
            'service_items_container_block',
            'service_selection_block',
            'service_selection_item_block',
            'services_block',
            'signatures_block'
        ];

        const containerChildren = childBlocks.filter(block =>
            ContainerableBlockTypes.includes(block.type)
        );

        containerChildren.forEach(block => {
            childBlocks = childBlocks.concat(
                (<CXContainerableBlock>block).allDescendants()
            );
        });

        return childBlocks;
    }
}
